//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
};
